<main class="content-page">
  <header>
    <div><p class="eyebrow">Mobile content</p><h1>Policies & app information</h1><p>Manage legal, safety, help, and company pages shown live in ZepBazaar.</p></div>
    <button class="secondary" type="button" (click)="newPage()">+ New page</button>
  </header>

  @if (error) { <p class="notice error">{{ error }}</p> }
  @if (message) { <p class="notice success">{{ message }}</p> }

  <section class="editor" style="margin-bottom: 24px">
    <div class="editor-title"><div><p class="eyebrow">Seller trust</p><h2>Verified badge offer</h2></div><label class="publish"><input type="checkbox" [(ngModel)]="verificationOffer.isEnabled" /> Enabled</label></div>
    <div class="two-columns">
      <label>Offer title<input [(ngModel)]="verificationOffer.title" /></label>
      <label>One-time price<input type="number" min="0" step="1" [(ngModel)]="verificationOffer.price" /></label>
      <label>Currency<input maxlength="3" [(ngModel)]="verificationOffer.currency" /></label>
    </div>
    <label>Description<textarea rows="3" [(ngModel)]="verificationOffer.description"></textarea></label>
    <footer><span class="muted">Changes appear live on the Get verified badge page.</span><button class="primary" type="button" [disabled]="savingOffer" (click)="saveVerificationOffer()">{{ savingOffer ? 'Saving…' : 'Save badge offer' }}</button></footer>
  </section>

  <section class="workspace">
    <aside class="page-list">
      <h2>Published content</h2>
      @if (loading) { <p class="muted">Loading from database…</p> }
      @for (page of pages; track page.id) {
        <button type="button" class="page-row" [class.active]="selectedId === page.id" (click)="edit(page)">
          <span class="material-symbols-outlined">{{ page.category === 'Legal' ? 'policy' : 'article' }}</span>
          <span><strong>{{ page.title }}</strong><small>{{ page.category }} · /{{ page.slug }}</small></span>
          <i [class.off]="!page.isPublished">{{ page.isPublished ? 'Live' : 'Draft' }}</i>
        </button>
      }
    </aside>

    <form class="editor" (ngSubmit)="save()">
      <div class="editor-title"><div><p class="eyebrow">{{ selectedId ? 'Edit page' : 'New page' }}</p><h2>{{ form.title || 'Untitled content' }}</h2></div><label class="publish"><input type="checkbox" name="published" [(ngModel)]="form.isPublished" /> Published</label></div>
      <div class="two-columns">
        <label>Title<input name="title" [(ngModel)]="form.title" required /></label>
        <label>URL slug<input name="slug" [(ngModel)]="form.slug" placeholder="privacy-policy" required pattern="[a-z0-9-]+" /></label>
        <label>Category<select name="category" [(ngModel)]="form.category"><option>Legal</option><option>Help</option><option>Safety</option><option>Company</option><option>Support</option></select></label>
        <label>Display order<input type="number" name="displayOrder" [(ngModel)]="form.displayOrder" /></label>
      </div>
      <label>Short description<input name="summary" [(ngModel)]="form.summary" maxlength="500" /></label>
      <label>Page content<textarea name="content" [(ngModel)]="form.content" rows="14" required placeholder="Write the content customers will read in the app…"></textarea></label>
      <footer><span class="muted">Changes appear in the app the next time this section opens.</span><button class="primary" type="submit" [disabled]="saving">{{ saving ? 'Saving…' : 'Save content' }}</button></footer>
    </form>
  </section>
</main>
